import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map, Set } from 'immutable';

import { OrphanProjectItemEntity } from './orphan-project-item.entity';

export interface IOrphanProjectListExtra
	extends IListColumnConfig<OrphanProjectItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IOrphanProjectListEntity extends IListAttrs<OrphanProjectItemEntity> {
	availableColumns: Map<string, IOrphanProjectListExtra>;
}

const entityDefaults: IOrphanProjectListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class OrphanProjectListEntity
	implements
		IOrphanProjectListEntity,
		IListOperations<OrphanProjectListEntity, OrphanProjectItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IOrphanProjectListExtra> = []
	): OrphanProjectListEntity {
		const instance = new OrphanProjectListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IOrphanProjectListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<OrphanProjectItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, OrphanProjectItemEntity>
	): OrphanProjectListEntity {
		return produce(this, (draft: OrphanProjectListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, item) => {
			if (!item.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...item.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}
}
